<template>
  <div class="wrapper">
    <div>
      <Form :model="reSearch" inline :label-width="90">
        <FormItem label="名称">
          <Input v-model="reSearch.name" clearable />
        </FormItem>
        <FormItem label="级别">
          <Select
            v-model="reSearch.grade_id"
            filterable
            clearable
            placeholder="请选择级别"
            style="width: 180px"
          >
            <Option
              v-for="item in scopeGradeList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="科目">
          <Select
            v-model="reSearch.subject_id"
            filterable
            clearable
            placeholder="请选择科目"
            style="width: 180px"
          >
            <Option
              v-for="item in scopeSubjectList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <div style="float: right;padding-right: 15px;">
          <Button type="primary" @click="tabChange(labelMsg)" icon="ios-search"
            >搜索</Button
          >
        </div>
        <div style="clear: both;"></div>
      </Form>
    </div>
    <Tabs @on-click="tabChange" :value="labelMsg">
      <TabPane label="我的课程" name="myCourseList">
        <myCourseList :reSearch="reSearch" ref="myCourseList" />
      </TabPane>
      <TabPane label="课程库" name="courseList">
        <courseList :reSearch="reSearch" ref="courseList" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import courseList from "./courseList.vue";
import myCourseList from "./myCourseList.vue";
import { mapState } from "vuex";
import scopeSearch from "../../mixins/scopeSearch";
export default {
  mixins: [scopeSearch],
  computed: {
    ...mapState({
      curseList(state) {
        this.curseLists = state.global.curseList;
      },
      subjectList(state) {
        return state.global.subjectList;
      }
    })
  },
  components: {
    courseList,
    myCourseList
  },
  data() {
    return {
      labelMsg: "myCourseList",
      curseLists: [],
      reSearch: {
        name: "",
        subject_id: "",
        grade_id: ""
      }
    };
  },
  mounted() {
    this.scopeSearchInit();
    // 初始化筛选列表
    this.$store.dispatch("global/getAllSelect");
  },
  methods: {
    // 切换时初始化数据
    tabChange(name) {
      this.labelMsg = name;
      if (name == "courseList") {
        this.$refs.courseList.search();
        this.$refs.courseList.getData(1);
      }
      if (name == "myCourseList") {
        this.$refs.myCourseList.search();
        this.$refs.myCourseList.getData(1);
      }
    },
    getcurse() {
      this.$axios
        .get("/app/curse/getList", {
          subject_id: this.reSearch.subject_id
        })
        .then(res => {
          if (res.code == 1) {
            this.curseLists = res.data;
          } else {
            this.$Message.error(res.msg);
          }
        });
    }
  }
};
</script>
<style scoped lang="less">
.wrapper {
  padding: 0 10px;
}
/deep/.ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #444;
}
/deep/.ivu-tabs-nav .ivu-tabs-tab-active {
  color: #444;
}
</style>
